import React from 'react';
export var OrganicShape = _ref => {
  var {
    size,
    color
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    viewBox: "0 0 205 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "organic-shape",
    opacity: "0.25",
    d: "M11.6412 87.8574C-29.9542 151.583 49.5 180.978 99.7388 180.978C149.156 180.978 205 162.334 205 104.919C205.082 -42.6764 83.0062 -21.606 11.6412 87.8574Z",
    fill: color || '#49E295'
  }));
};
//# sourceMappingURL=OrganicShape.js.map